import { render, staticRenderFns } from "./createOrder.vue?vue&type=template&id=3a3e0f68&scoped=true&"
import script from "./createOrder.vue?vue&type=script&lang=js&"
export * from "./createOrder.vue?vue&type=script&lang=js&"
import style0 from "./createOrder.vue?vue&type=style&index=0&id=3a3e0f68&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3e0f68",
  null
  
)

export default component.exports